export const ERROR_ALERT = 'ERROR_ALERT';
export const SET_WALLET = 'SET_WALLET';
export const SET_WALLET_SUCCESS = 'SET_WALLET_SUCCESS';
export const RESET_WALLET = 'RESET_WALLET';
export const SET_DESTINATION_TAG = 'SET_DESTINATION_TAG';
export const SET_PAYMENT_ID = 'SET_PAYMENT_ID';
export const SET_MEMO = 'SET_MEMO';
export const COIN_SELECTED = 'COIN_SELECTED';
export const COINS_INFO = 'COINS_INFO';
export const PRICE_FETCHED = 'PRICE_FETCHED';
export const PAIRS_FETCHED = 'PAIRS_FETCHED';
export const INVALID_AMOUNT = 'INVALID_AMOUNT';
export const SET_ORDER = 'SET_ORDER';
export const SET_KYC = 'SET_KYC';
export const SET_EMAIL = 'SET_EMAIL';
export const SET_EMAIL_AND_MESSAGE = 'SET_EMAIL_AND_MESSAGE';
export const FETCHING_PRICE = 'FETCHING_PRICE';
export const SHOW_SUPPORT_MODAL = 'SHOW_SUPPORT_MODAL';
export const SHOW_WALLET_ADDRESS_MODAL = 'SHOW_WALLET_ADDRESS_MODAL';
export const FORCE_WALLET_ADDRESS_MODAL = 'FORCE_WALLET_ADDRESS_MODAL';
//ORDER BOOK
export const ORDER_MODE_CHANGE = 'ORDER_MODE_CHANGE';
export const ORDER_BOOK_VALUE_CHANGE = 'ORDER_BOOK_VALUE_CHANGE';
export const ORDER_BOOK_DATA_FETCHED = 'ORDER_BOOK_DATA_FETCHED';

export const AUTH_TOKEN_RECEIVED = 'AUTH_TOKEN_RECEIVED';
export const AUTH_USER_PROFILE = 'AUTH_USER_PROFILE';
export const AUTH_FAILED = 'AUTH_FAILED';
export const AUTH_COMPLETE = 'AUTH_COMPLETE';
export const AUTH_LOADING = 'AUTH_LOADING';
export const AUTH_SIGN_OUT = 'AUTH_SIGN_OUT';
export const AUTH_LOAD_ORDERS = 'AUTH_LOAD_ORDERS';
export const AUTH_SIGN_UP = 'AUTH_SIGN_UP';
export const AUTH_USER_REGISTERED = 'AUTH_USER_REGISTERED';
export const AUTH_REGISTRATION_FAILED = 'AUTH_REGISTRATION_FAILED';
export const AUTH_PASSWORD_RESET = 'AUTH_PASSWORD_RESET';
export const AUTH_PASSWORD_RESET_SUCCESS = 'AUTH_PASSWORD_RESET_SUCCESS';
export const AUTH_PASSWORD_RESET_FAILED = 'AUTH_PASSWORD_RESET_FAILED';
export const AUTH_REGISTRATION_COMPLETE = 'AUTH_REGISTRATION_COMPLETE';
